import {NgModule} from '@angular/core';
import {TerminaConsultaComponent} from './termina-consulta.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {I18nModule} from "../../shared/i18n/i18n.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        I18nModule
    ],
    exports: [TerminaConsultaComponent],
    declarations: [TerminaConsultaComponent]
})
export class TerminaConsultaModule {
}
